export default "__VITE_ASSET__ed70ec7a__"